import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRootEntity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 10.694V5.30598C14 4.82931 13.746 4.38931 13.3333 4.15131L8.66667 1.45731C8.254 1.21931 7.746 1.21931 7.33333 1.45731L2.66667 4.15064C2.254 4.38931 2 4.82931 2 5.30598V10.6946C2 11.1713 2.254 11.6113 2.66667 11.8493L7.33333 14.5433C7.746 14.7813 8.254 14.7813 8.66667 14.5433L13.3333 11.8493C13.746 11.6106 14 11.1706 14 10.694Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 14.72L8 11.0068",
			stroke: "currentColor",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7817 5.81657L10.3487 6.06656L10.8487 6.9326L11.2817 6.68261L11.0317 6.24959L10.7817 5.81657ZM14.0698 5.07303C14.3089 4.93497 14.3908 4.62918 14.2528 4.39003C14.1147 4.15088 13.8089 4.06893 13.5698 4.207L13.8198 4.64001L14.0698 5.07303ZM11.0317 6.24959L11.2817 6.68261L14.0698 5.07303L13.8198 4.64001L13.5698 4.207L10.7817 5.81657L11.0317 6.24959Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.36182 4.74475L4.96969 6.25041",
			stroke: "currentColor",
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 2,
			fill: "currentColor"
		})
	]
});
export { SvgRootEntity as ReactComponent };
